export const logos = [
  '/images/frontpage-logo-images/gema.png',
  '/images/frontpage-logo-images/universal-music-group.png',
  '/images/frontpage-logo-images/sony-music.png',
  '/images/frontpage-logo-images/embassy-one.png',
  '/images/frontpage-logo-images/warner-music.png',
]
